import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,Events} from 'ionic-angular';
import * as L from 'leaflet';
import Polygon = L.Polygon;
import Marker = L.Marker;
import Icon = L.Icon;
import 'leaflet';
import {
  MapService
} from "../../utils/map.service";
import {
  HistoricalService
} from "../../providers/historical.service";
import {
 GlobalService
} from './../../providers/global.config';
import {
  DataManagementService
} from "../../providers/data-management.service";
import {
  DatePipe,
  DecimalPipe
} from '@angular/common';
import {
  Stop,
  Mileage
} from '../../objects/real-time';
import {
  MileageComponent
} from '../mileage/mileage';
/**
 * Generated class for the LeafletmapPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-leafletmap',
  templateUrl: 'leafletmap.html',
})
export class LeafletmapPage {

path : any;
stop : any;
kilo : any;
mileageClicked: Mileage;
stopClicked: Stop;
imagesDir = this.globalService.getimagesDir();
imagesPOIDir = this.globalService.getimagesPOIDir();

listOfpoints: any[]=[];
marker = L.marker([0,0]);

numberOfpoints : number = 0;

  constructor(public navCtrl: NavController,
 public mapService: MapService,
   public navParams: NavParams,
    private historicalService: HistoricalService,
    private dataManagementService: DataManagementService,
    public events: Events,
    private globalService : GlobalService) {

/*this.path = this.navParams.get('path');
console.log(this.path);*/

  events.subscribe('selectedPath', x => {
      if (x) {
      this.path =x;
     //console.log(this.path);
     console.log("entering path");
      }
    });

 events.subscribe('selectedStop', x => {
      if (x) {
      this.stop =x;
     //console.log(this.path);
     console.log("entering stop");
      }
    });

 events.subscribe('selectedKilo', x => {
      if (x) {
      this.kilo =x;
     //console.log(this.path);
     console.log("entering path");
      }
    });

this.callPath();
this.callStop();
this.callKilo();


  }



 callPath(){
this.events.publish("path");
}


callStop(){
this.events.publish("stop");
}

callKilo(){
this.events.publish("kilo");
}




ngOnInit() {
 
   this.initMap();
   console.log(this.path);
   if (this.path){
     this.drawPath(this.path);
     this.path = 'undefined';
  
   }
   console.log(this.stop);
   if (this.stop){
     this.drawStop(this.stop);
     this.stop = 'undefined';
  
   }
   console.log(this.kilo);
   if (this.kilo){
     this.drawMileage(this.kilo);
     this.kilo = null;
  
   }
 
   }

 //initialisation du map
  initMap() {
 /*     let view = this.navCtrl.getActive();
    if (view.component.name != "HistoricalForm")
 {
*/
    if (this.mapService.map){
     this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
       this.mapService.map.off();
       this.mapService.map.remove();
     } 
    

    let map = L.map('historicalMap2', {
      zoomControl: false,
      center: L.latLng(36.754423, 10.197877),
      zoom: 13,
      minZoom: 3,
      maxZoom: 20,
      //maxNativeZoom: 17,
      layers: [this.mapService.baseMaps.googlehybride]
    });
    L.control.layers(this.mapService.baseMaps, null, {
      position: 'bottomright'
    }).addTo(map);
    L.control.zoom({
      position: 'bottomleft'
    }).addTo(map);
    this.mapService.map = map;
    this.onMapReady(this.mapService.map);
    console.log("map all good");
    this.mapService.mapLoaded.emit(true);
      
      
// }

}

onMapReady(map: L.Map) {
    setTimeout(() => {
      map.invalidateSize();
    }, 0);
 }





playbackPath(index){
  
 // this.listOfpoints[index]
 //this.mapService.removeMarkersFromMap();
 this.mapService.map.removeLayer(this.marker);
 console.log(index.value);
 //console.log(this.listOfpoints[index.value]);
 let selectedRange : any[] = [];
 selectedRange.push(this.listOfpoints[index.value]);
console.log(selectedRange);

 selectedRange.forEach(point => {

          console.log(point);
         this.marker.setLatLng([point.lat,point.lng]);

          this.marker.setIcon(new Icon({
            iconUrl: this.imagesDir + "car.png",
            iconAnchor: [2, 2]
          }));
         var pointDatePipe = new DatePipe(point.date);
          let popup = '<b>Heure:</b> ' + pointDatePipe.transform(point.date, 'dd/MM/yyyy HH:mm:ss') + '<b><br>vitesse:</b> ' + point.speed + ' Km/h';
          this.marker.bindPopup(popup);
          this.mapService.addMarker(this.marker);
          this.mapService.map.setView([point.lat,point.lng], 17);

 });
 




}





// desiner le trajet
  drawPath(path: any) {

    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    this.historicalService.getPathDetails(path.deviceId, {
      startDate: path.beginPathTime,
      endDate: path.endPathTime
    }).subscribe(points => {
      let stopMarkers: Marker[] = [];
      points.stops.forEach(stop => {
        let popup = "<img src='" + this.imagesDir + "stop_smal.png" + "'/> Durée d'arrêt : " + stop.stopDurationStr;
        let stopMarker = L.marker({
          lat: stop.stopLatitude,
          lng: stop.stopLongitude
        });
        stopMarker.addTo(this.mapService.map);
        stopMarker.on('click', () => {
          this.mapService.map.setView({
            lat: stop.stopLatitude,
            lng: stop.stopLongitude
          }, 14);
        });
        this.dataManagementService.inverseGeoconding(stop.stopLatitude, stop.stopLongitude, 18).subscribe(adress => {
          let truncatedDisplayName = adress.display_name;
          let countCommas = 0;
          for (var i = 0, len = adress.display_name.length; i < len; i++) {
            if (adress.display_name[i] == ',') {
              countCommas = countCommas + 1;
            } else if (countCommas >= 5) {
              truncatedDisplayName = adress.display_name.substring(0, i - 1);
              break;
            }
          }
          popup = popup + '<br><hr><b>' + truncatedDisplayName + '</b>';
          stopMarker.bindPopup(popup);
        });
        stopMarker.setIcon(new Icon({
          iconUrl: this.imagesDir + "stop_smal.png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -25]
        }));
        this.mapService.addMarker(stopMarker);
      });
      let polyline = L.polyline(points.coordinates, {
        color: '#0031D9',
        weight: 3
      });



//----------------------------------------------------




      points.coordinates.forEach((coordinate, i) => {
        //console.log(coordinate);
        this.numberOfpoints = this.numberOfpoints + 1;
       
        this.listOfpoints.push(coordinate);
        //console.log(this.listOfpoints);

        let marker = L.marker(coordinate);
        if (i != 0 && i != points.coordinates.length - 1) {
          marker.setIcon(new Icon({
            iconUrl: this.imagesDir + "green-point.png",
            iconAnchor: [2, 2]
          }));
         /* var pointDatePipe = new DatePipe(coordinate.date);
          let popup = '<b>Heure:</b> ' + pointDatePipe.transform(coordinate.date, 'dd/MM/yyyy HH:mm:ss') + '<b><br>vitesse:</b> ' + coordinate.speed + ' Km/h';
          marker.bindPopup(popup);
          marker.on('click', () => {
            this.mapService.map.setView(coordinate, 17);
          });*/
          this.mapService.addMarker(marker);
        }
      });
this.numberOfpoints = this.numberOfpoints -1 ;
 console.log(this.numberOfpoints);
console.log(this.listOfpoints);




//------------------------------------------

      let startMarker = L.marker({
        lat: path.beginPathLatitude,
        lng: path.beginPathLongitude
      });
      let startTime: any = path.beginPathTime;
      var startDatePipe = new DatePipe(startTime);
      startMarker.bindPopup('<b> Lieu de début: </b>' + path.beginPathGeocoding + '<b></i><br>Temps de début du trajet : </b>' + startDatePipe.transform(startTime, 'dd/MM/yyyy HH:mm:ss'));
      startMarker.setIcon(new Icon({
        iconUrl: this.imagesDir + "startMarker.png",
        iconAnchor: [-2, 30],
        popupAnchor: [10, -25]
      }));
      this.mapService.addMarker(startMarker);
      if (path.endPathLatitude != null && path.endPathLongitude != null && path.endPathTime != null) {
        var endMarker = L.marker({
          lat: path.endPathLatitude,
          lng: path.endPathLongitude
        });
        let endTime: any = path.endPathTime;
        var endDatePipe = new DatePipe(endTime);
        endMarker.bindPopup('<b> Lieu de fin: </b>' + path.endPathGeocoding + '<br><b>Temps de fin du trajet : </b>' + endDatePipe.transform(endTime, 'dd/MM/yyyy HH:mm:ss') +
          '<br><b> Durée du trajet : </b>' + path.pathDurationStr + "<br><b> Durée d'arrêt : </b>" + path.nextStopDurationStr + "<br><b> Vitesse maximum : </b>" +
          path.maxSpeed + " Km/h <br><b> Kilometrage parcouru : </b>" + path.distanceDriven.toFixed(2) + ' Km'
        );
        endMarker.setIcon(new Icon({
          iconUrl: this.imagesDir + "endMarker.png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -25]
        }));
        this.mapService.addMarker(endMarker);
      }
      this.mapService.addPolyline(polyline);
      var middle = points.coordinates[Math.round((points.coordinates.length - 1) / 2)];
      this.mapService.map.setView(middle, 12);
    });
   // this.modalopen = true;
  }




//draw arret
  drawStop(stop: Stop) {
    if (this.stopClicked == null || this.stopClicked.beginStopTime != stop.beginStopTime) {
      this.stopClicked = new Stop();
      this.stopClicked.beginStopTime = stop.beginStopTime;
      this.stopClicked.endStopTime = stop.endStopTime;
    }
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    let marker = L.marker({
      lat: stop.stopLatitude,
      lng: stop.stopLongitude
    });
    let date = new Date(stop.beginStopTime);
    let beginStopTime: any = stop.beginStopTime;
    var pointDatePipe = new DatePipe(beginStopTime);
    let popup = "<b>Date debut d'arrêt: </b>" + pointDatePipe.transform(stop.beginStopTime, 'dd/MM/yyyy HH:mm:ss') + "<br><b>Durée d'arrêt: </b>" + stop.stopDurationStr + "<br><hr><b>" + stop.geocodingDetails + "</b>";
    marker.setIcon(new Icon({
      iconUrl: this.imagesDir + "endMarker.png",
      iconAnchor: [-2, 30],
      popupAnchor: [10, -25]
    }));
    marker.bindPopup(popup);
    marker.on('click', () => {
      this.mapService.map.setView({
        lat: stop.stopLatitude,
        lng: stop.stopLongitude
      }, 17);
    });
    marker.on('add', () => {
      marker.openPopup();
    });
    this.mapService.addMarker(marker);
    this.mapService.map.setView({
      lat: stop.stopLatitude,
      lng: stop.stopLongitude
    }, 15);
  }


  // draw Kilometrage
  drawMileage(mileage: any) {
    if (this.mileageClicked == null || this.mileageClicked.startHour != mileage.startHour) {
      this.mileageClicked = new Mileage();
      this.mileageClicked.startHour = mileage.startHour;
      this.mileageClicked.endHour = mileage.endHour;
    }
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    let startHour: any = mileage.startHour - (2 * 60 * 60 * 1000);
    this.historicalService.getMileageDetails(mileage.deviceId, {
      startDate: startHour,
      endDate: mileage.endHour
    }).subscribe(mileage => {
      let points = mileage.points;
      let stops = mileage.stops;
      let polyline = L.polyline(points, {
        color: '#0031D9',
        weight: 3
      });
      points.forEach((coordinate, i) => {
        let marker = L.marker(coordinate);
        if (i != 0 && i != points.length - 1) {
          marker.setIcon(new Icon({
            iconUrl: this.imagesDir + "green-point.png",
            iconAnchor: [2, 2]
          }));
          var pointDatePipe = new DatePipe(coordinate.date);
          let popup = '<b>Heure:</b> ' + pointDatePipe.transform(coordinate.date, 'dd/MM/yyyy HH:mm:ss') + '<b><br>vitesse:</b> ' + coordinate.speed + ' Km/h';
          marker.bindPopup(popup);
          marker.on('click', () => {
            this.mapService.map.setView(coordinate, 17);
          });
          this.mapService.addMarker(marker);
        }
      });
      stops.forEach((stop, i) => {
        let marker = L.marker({
          lat: stop.stopLatitude,
          lng: stop.stopLongitude
        });
        var pointDatePipe = new DatePipe(stop.beginStopTime);
        let popup = "<b>Date debut d'arrêt: </b>" + pointDatePipe.transform(stop.beginStopTime, 'dd/MM/yyyy HH:mm:ss') + "<br><b>Durée d'arrêt: </b>" + stop.stopDurationStr;
        marker.setIcon(new Icon({
          iconUrl: this.imagesDir + "stop_smal.png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -25]
        }));
        marker.bindPopup(popup);
        marker.on('click', () => {
          this.mapService.map.setView({
            lat: stop.stopLatitude,
            lng: stop.stopLongitude
          }, 17);
        });
        this.mapService.addMarker(marker);
      });
      this.mapService.addPolyline(polyline);
      var middle = points[Math.round((points.length - 1) / 2)];
      //map center offset(axis y)
      // this.mapService.offsetMap(middle, 12, 0, -120);
    });
  }
























}





// WEBPACK FOOTER //
// ./src/pages/leafletmap/leafletmap.ts